export const PENDING_STATUS = 'pending';
export const SUCCESS_STATUS = 'success';
export const ERROR_STATUS = 'error';
export const COMPLETED_STATUS = 'completed';
export const UNDEFINED_STATUS = '';
